import { Grid, Button, Divider } from "@material-ui/core";
import React, { useState } from "react";
import useStyles from "../../../components/styles/styles";
import Input from "../../../components/utils/Input";
import Api from "../../../constant/Api";
import { useHistory } from "react-router-dom";
import { postRequest } from "../../../constant/ApiService";
import { toast } from "react-toastify";
import PageTitle from "../../../components/PageTitle/PageTitle";

const OrderByWaybill = () => {
    const classes = useStyles();
    const history = useHistory();
    const [NewContent, setNewContent] = useState({
        serial: "",
        number: "",
        year: ""
    });

    const [wayBillModel, setWayBillModel] = useState({
        wayBill: "",
        created: "",
        createdEn: "",
        sourceAddress: "",
        senderName: "",
        senderPhoneNumber: "",
        senderPostalCode: "",
        destAddress: "",
        receiveName: "",
        receivePhoneNumber: "",
        receivePostalCode: "",
        title: "",
        weight: "",
        packing: "",
        insuranceAmmount: "",
        payBill: "",
        driverFirstName: "",
        driverLastName: "",
        driverNationlId: "",
        driverPhoneNumber: "",
        driverSmartCode: "",
        driverCity: "",
        driverBirthday: "",
        truckType: "",
        truckCarrier: "",
        truckBrandName: "",
        truckConstruction: "",
        truckSmartCode: ""
    });

    const search = () => {
        if (!NewContent.serial) {
            toast.error("سریال برنامه را وارد کنید");
            return;
        }

        if (!NewContent.number) {
            toast.error("شماره بارنامه را وارد کنید");
            return;
        }

        if (!NewContent.year) {
            toast.error("سال بارنامه را وارد کنید");
            return;
        }

        let body = {
            serial: NewContent.serial,
            number: NewContent.number,
            year: NewContent.year,
        };
        postRequest(Api.GetWayBill, body).then(res => {
            if (res && res.succeeded && res.succeeded == true) {
                toast.success(res.message);
                setWayBillModel({
                    wayBill: res.data?.wayBill || "",
                    created: res.data?.created || "",
                    createdEn: res.data?.createdEn || "",
                    sourceAddress: res.data?.sourceAddress || "",
                    senderName: res.data?.senderName || "",
                    senderPhoneNumber: res.data?.senderPhoneNumber || "",
                    senderPostalCode: res.data?.senderPostalCode || "",
                    destAddress: res.data?.destAddress || "",
                    receiveName: res.data?.receiveName || "",
                    receivePhoneNumber: res.data?.receivePhoneNumber || "",
                    receivePostalCode: res.data?.receivePostalCode || "",
                    title: res.data?.title || "",
                    weight: res.data?.weight || "",
                    packing: res.data?.packing || "",
                    insuranceAmmount: res.data?.insuranceAmmount || "",
                    payBill: res.data?.payBill || "",
                    driverFirstName: res.data?.driverFirstName || "",
                    driverLastName: res.data?.driverLastName || "",
                    driverNationlId: res.data?.driverNationlId || "",
                    driverPhoneNumber: res.data?.driverPhoneNumber || "",
                    driverSmartCode: res.data?.driverSmartCode || "",
                    driverBirthday: res.data?.driverBirthday || "",
                    driverCity: res.data?.driverCity || "",
                    truckType: res.data?.truckType || "",
                    truckCarrier: res.data?.truckCarrier || "",
                    truckBrandName: res.data?.truckBrandName || "",
                    truckConstruction: res.data?.truckConstruction || "",
                    truckSmartCode: res.data?.truckSmartCode || ""
                });
            } else {
                toast.error("سرویس در دسترس نمی باشد");
            }
        });
    };


  const register = () => {
        if (!wayBillModel.driverPhoneNumber || wayBillModel.driverPhoneNumber == '') {
            toast.error(" شماره راننده را وارد کنید");
            return;
        }

         if (!wayBillModel.insuranceAmmount || wayBillModel.insuranceAmmount == '') {
            toast.error(" ارزش بیمه را وارد کنید");
            return;
        }

    
        postRequest(Api.CreateCargoByWayBill, wayBillModel).then(res => {
            if (res && res.succeeded && res.succeeded == true) {
                toast.success(res.message);
            } else {
                toast.error("سرویس در دسترس نمی باشد");
            }
        });
    };


    return (
        <Grid>
            <PageTitle title=" ثبت بار با بارنامه" />
            <Grid container>
                <Grid
                    className={classes.colItem}
                    item
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <label>شماره بارنامه</label>
                    <Input
                        name="content"
                        value={NewContent.number}
                        onChange={({ target }) =>
                            setNewContent(state => ({
                                ...state,
                                number: target.value,
                            }))
                        }
                        type="text"
                    />
                </Grid>
                <Grid
                    className={classes.colItem}
                    item
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <label>شماره سریال</label>
                    <Input
                        name="content"
                        value={NewContent.serial}
                        onChange={({ target }) =>
                            setNewContent(state => ({
                                ...state,
                                serial: target.value,
                            }))
                        }
                        type="text"
                    />
                </Grid>
                <Grid
                    className={classes.colItem}
                    item
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                    xs={12}
                >
                    <label>سال</label>
                    <Input
                        name="content"
                        value={NewContent.year}
                        onChange={({ target }) =>
                            setNewContent(state => ({
                                ...state,
                                year: target.value,
                            }))
                        }
                        type="text"
                    />
                </Grid>

            </Grid>

            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="space-between"
                direction="row-reverse"
            >
                <Button
                    variant="contained"
                    style={{ color: "#fff", backgroundColor: "#3CD4A0", margin: "30px 0" }}
                    onClick={search}
                >
                    جستجو{" "}
                </Button>
            </Grid>


            <Divider style={{ width: "100%", margin: "10px 0" }} />

            <Grid container alignItems="center" justifyContent="space-between">
                <h3>جزییات آدرس</h3>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>مبدا</label>
                        <Input
                            name="content"
                            value={wayBillModel.sourceAddress}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    sourceAddress: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نام فرستنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.senderName}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    senderName: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره همراه فرستنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.senderPhoneNumber}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    senderPhoneNumber: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>کدپستی فرستنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.senderPostalCode}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    senderPostalCode: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>مقصد</label>
                        <Input
                            name="content"
                            value={wayBillModel.destAddress}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    destAddress: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نام گیرنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.receiveName}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    receiveName: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره همراه گیرنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.receivePhoneNumber}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    receivePhoneNumber: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>کدپستی گیرنده</label>
                        <Input
                            name="content"
                            value={wayBillModel.receivePostalCode}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    receivePostalCode: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                </Grid>

            </Grid>


            <Grid container alignItems="center" justifyContent="space-between">
                <h3>جزییات بار</h3>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>عنوان بار</label>
                        <Input
                            name="content"
                            value={wayBillModel.title}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    title: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>وزن بار</label>
                        <Input
                            name="content"
                            value={wayBillModel.weight}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    weight: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نوع بسته بندی</label>
                        <Input
                            name="content"
                            value={wayBillModel.packing}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    packing: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>ارزش بیمه (میلیون تومان)</label>
                        <Input
                            name="content"
                            value={wayBillModel.insuranceAmmount}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    insuranceAmmount: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>کرایه (ریال)</label>
                        <Input
                            name="content"
                            value={wayBillModel.payBill}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    payBill: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>تاریخ</label>
                        <Input
                            name="content"
                            value={wayBillModel.created}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    created: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                </Grid>

            </Grid>


            <Grid container alignItems="center" justifyContent="space-between">
                <h3>مشخصات راننده</h3>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نام</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverFirstName}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverFirstName: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نام خانوادگی</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverLastName}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverLastName: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>تاریخ تولد</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverBirthday}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverBirthday: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره ملی</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverNationlId}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverNationlId: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره همراه</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverPhoneNumber}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverPhoneNumber: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره هوشمند</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverSmartCode}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverSmartCode: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شهر</label>
                        <Input
                            name="content"
                            value={wayBillModel.driverCity}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    driverCity: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                </Grid>

            </Grid>


            <Grid container alignItems="center" justifyContent="space-between">
                <h3>مشخصات وسیله نقلیه</h3>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>ناوگان</label>
                        <Input
                            name="content"
                            value={wayBillModel.truckType}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    truckType: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>بارگیر</label>
                        <Input
                            name="content"
                            value={wayBillModel.truckCarrier}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    truckCarrier: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>شماره ناوگان</label>
                        <Input
                            name="content"
                            value={wayBillModel.truckSmartCode}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    truckSmartCode: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>نوع برند</label>
                        <Input
                            name="content"
                            value={wayBillModel.truckBrandName}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    truckBrandName: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid
                        className={classes.colItem}
                        item
                        xl={3}
                        lg={3}
                        md={3}
                        sm={12}
                        xs={12}
                    >
                        <label>سال ساخت کامیون</label>
                        <Input
                            name="content"
                            value={wayBillModel.truckConstruction}
                            onChange={({ target }) =>
                                setWayBillModel(state => ({
                                    ...state,
                                    truckConstruction: target.value,
                                }))
                            }
                            type="text"
                        />
                    </Grid>

                </Grid>

            </Grid>

            <Grid
                item
                xs={12}
                sm={12}
                md={12}
                container
                justifyContent="space-between"
                direction="row-reverse"
            >
                <Button
                    variant="contained"
                    style={{ color: "#fff", backgroundColor: "#3CD4A0", margin: "30px 0" }}
                    onClick={register}
                >
                    تایید و ثبت بار{" "}
                </Button>
            </Grid>
        </Grid>


    );
};
export default OrderByWaybill;
